/**
 * <size-chart-opener> — opens the size chart popup when its inner link/button is
 * clicked, instead of navigating to the size guide page.
 *
 * Progressive enhancement: the inner element is a real <a href="{page.url}">, so
 * with no JS (or if the modal isn't present) the click just navigates to the page.
 * The popup itself is a <modal-dialog> (global.js) referenced by data-modal.
 */
if (!customElements.get('size-chart-opener')) {
  class SizeChartOpener extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      const trigger = event.target.closest('a, button');
      if (!trigger || !this.contains(trigger)) return;

      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal && typeof modal.show === 'function') {
        event.preventDefault();
        modal.show(trigger);
      }
      // else: let the <a href> navigate to the size guide page (no-JS fallback).
    }
  }

  customElements.define('size-chart-opener', SizeChartOpener);
}
